import React, { MouseEventHandler, PropsWithChildren } from 'react';
import { ScrollContainer } from '../../scroll-container/ScrollContainer';
import styles from './DropdownMenu.module.scss';

export const DropdownMenu = ({
    children, onClick, maxHeight = 500
}: Props) => (
    <div className={styles.default} onClick={onClick}>
        <ScrollContainer maxHeight={maxHeight}>
            {children}
        </ScrollContainer>
    </div>
);

type Props = PropsWithChildren<{
    onClick: MouseEventHandler,
    maxHeight?: number
}>;
